/* Hyro Vault Wrapped v9: standalone Check my guesses page (Apollo, 28 Sep 2026).
   Sends only the typed email to the lookup API; renders that email's codes scored against the winning code. */
(function () {
  "use strict";
  function esc(s) { return String(s == null ? "" : s).replace(/[&<>"']/g, function (c) { return { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" }[c]; }); }
  function marks(code, win) {
    var m = ["no", "no", "no", "no"], left = {};
    for (var i = 0; i < 4; i++) { if (code[i] === win[i]) m[i] = "ok"; else left[win[i]] = (left[win[i]] || 0) + 1; }
    for (var j = 0; j < 4; j++) if (m[j] !== "ok" && left[code[j]]) { m[j] = "sw"; left[code[j]]--; }
    return m;
  }
  function spaced(c) { return String(c).split("").join(" "); }
  function render(res, d) {
    if (!d || !d.found) {
      res.innerHTML = '<p class="ap-cmg__msg">' + esc((d && d.message) || "No guesses found for that email.") + '</p><p class="ap-cmg__fine">Check the spelling, or try the email on your Hyro order.</p>';
      return;
    }
    var b = d.best, bm = marks(b.code, d.winningCode);
    res.innerHTML = '<p class="ap-cmg__lbl">Your closest guess' + (d.preview ? '<span class="ap-cmg__tag">Preview code</span>' : '') + '</p>' +
      '<div class="ap-cmg__digits">' + b.code.split("").map(function (c, i) { return '<span class="' + bm[i] + '">' + esc(c) + '</span>'; }).join("") + '</div>' +
      '<p class="ap-cmg__verdict">' + esc(d.verdict) + '</p>' +
      '<p class="ap-cmg__how">' + b.spot + ' digit' + (b.spot === 1 ? '' : 's') + ' in the right spot, ' + b.swap + ' right digit' + (b.swap === 1 ? '' : 's') + ' in the wrong spot.' +
        (d.beatPct > 0 ? ' Closer than ' + esc(d.beatPct) + '% of all guesses.' : '') + '</p>' +
      '<p class="ap-cmg__lbl" style="margin-top:18px">All your guesses vs ' + esc(spaced(d.winningCode)) + '</p>' +
      '<div class="ap-cmg__chips">' + d.guesses.map(function (g) {
        var m = marks(g.code, d.winningCode);
        return '<span class="ap-cmg__chip" title="' + g.spot + ' right spot, ' + g.swap + ' wrong spot">' + g.code.split("").map(function (c, i) { return '<span class="' + m[i] + '">' + esc(c) + '</span>'; }).join("") + '</span>';
      }).join("") + '</div>' +
      '<div class="ap-cmg__key"><span><b class="ok">Green</b> right spot</span><span><b class="sw">Gold</b> right digit, wrong spot</span></div>';
  }
  function init(root) {
    if (root.__apcmg) return; root.__apcmg = 1;
    var form = root.querySelector(".ap-cmg__form"), input = root.querySelector(".ap-cmg__input"), btn = root.querySelector(".ap-cmg__btn"), res = root.querySelector(".ap-cmg__res");
    var endpoint = root.getAttribute("data-endpoint");
    if (!form || !endpoint) return;
    form.addEventListener("submit", function (e) {
      e.preventDefault();
      var email = input.value.trim();
      if (!/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(email)) { res.innerHTML = '<p class="ap-cmg__msg">Enter the email you played with.</p>'; return; }
      btn.disabled = true; btn.textContent = "Checking";
      fetch(endpoint, { method: "POST", mode: "cors", credentials: "omit", headers: { "content-type": "application/json" }, body: JSON.stringify({ email: email }) })
        .then(function (r) { return r.json().catch(function () { return { found: false, message: "Something went wrong. Try again." }; }); })
        .then(function (d) { render(res, d); })
        .catch(function () { render(res, { found: false, message: "Could not reach the Vault. Try again." }); })
        .then(function () { btn.disabled = false; btn.textContent = "Check my guesses"; });
    });
  }
  function boot() { Array.prototype.forEach.call(document.querySelectorAll(".ap-cmg"), init); }
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", boot); else boot();
  document.addEventListener("shopify:section:load", boot);
})();
